module.exports = __webpack_public_path__ + "static/media/output.3fee7a0d.png";